export const ADD_NEW_COMMUNITY = "ADD_NEW_COMMUNITY";
export const REMOVE_COMMUNITY = "REMOVE_COMMUNITY";
